import React from "react";
import {
  Files,
  FileEarmarkPdf,
  FileEarmarkSpreadsheet,
  Printer
} from "react-bootstrap-icons";
import { exportPDF, exportCSV, copyTable, printTable } from "./ExportUtils";

export const FileExportBtn = ({
  copy,
  csv,
  pdf,
  print,
  modifiedColumns,
  rows,
  prepareRow,
  fileName
}) => {
  return (
    <>
      {(copy || csv || pdf || print) && (
        <div className="mb-3 d-flex gap-2 justify-content-center justify-content-lg-end">

          {copy && (
            <button
              className="btn btn-primary btn-sm d-flex align-items-center gap-1"
              onClick={(e) => {
                e.preventDefault();
                copyTable({ rows, columns: modifiedColumns, prepareRow, fileName });
              }}
            >
              <Files size={14} />
              Copy
            </button>
          )}

          {csv && (
            <button
              className="btn btn-primary btn-sm d-flex align-items-center gap-1"
              onClick={(e) => {
                e.preventDefault();
                exportCSV({ rows, columns: modifiedColumns, prepareRow, fileName });
              }}
            >
              <FileEarmarkSpreadsheet size={14} />
              CSV
            </button>
          )}

          {pdf && (
            <button
              className="btn btn-primary btn-sm d-flex align-items-center gap-1"
              onClick={(e) => {
                e.preventDefault();
                exportPDF({ rows, columns: modifiedColumns, prepareRow, fileName });
              }}
            >
              <FileEarmarkPdf size={14} />
              PDF
            </button>
          )}

          {print && (
            <button
              className="btn btn-primary btn-sm d-flex align-items-center gap-1"
              onClick={(e) => {
                e.preventDefault();
                printTable({ rows, columns: modifiedColumns, prepareRow, fileName });
              }}
            >
              <Printer size={14} />
              Print
            </button>
          )}
        </div>
      )}
    </>
  );
};
